package utils

import b2d.*
import com.soywiz.korge.box2d.*
import com.soywiz.korge.view.*
import com.soywiz.korma.geom.*
import component.*
import org.jbox2d.collision.shapes.*
import org.jbox2d.common.*
import org.jbox2d.dynamics.*

object PlayerBuilder {

    const val PLAYER_RADIUS = 28.0

    fun Container.buildPlayerContainer(
        posX: Double,
        posY: Double,
        sprite: Sprite,
        world: World,
    ): PlayerMetadata {
        val playerBody = world.createBody(BodyDef().apply {
            type = BodyType.DYNAMIC
//            angle
//            angularVelocity
            position.set(posX / world.customScale, posY / world.customScale)
            linearVelocity.set(0.0f, 0.0f)
            linearDamping = 0.3f
            angularDamping = 0.0f
            gravityScale = 1.0f
            allowSleep = false
            fixedRotation = true
            bullet = true
            awake = true
            active = true
        })

        val playerPhysicState = PlayerPhysicState(playerBody)
        playerBody.userData = playerPhysicState

        val scaledPlayerRadius = PLAYER_RADIUS / world.customScale

        val playerFixture = playerBody.createFixture(FixtureDef().apply {
            shape = PolygonShape().apply {
                count = 4
                count = 4
                vertices[0].set(-scaledPlayerRadius * 0.6, -scaledPlayerRadius * 0.5)
                vertices[1].set(scaledPlayerRadius * 0.6, -scaledPlayerRadius * 0.5)
                vertices[2].set(scaledPlayerRadius * 0.6, scaledPlayerRadius)
                vertices[3].set(-scaledPlayerRadius * 0.6, scaledPlayerRadius)
                normals[0].set(0.0f, -1.0f)
                normals[1].set(1.0f, 0.0f)
                normals[2].set(0.0f, 1.0f)
                normals[3].set(-1.0f, 0.0f)
                centroid.setZero()
            }
//            shape = CircleShape(PLAYER_RADIUS / world.customScale)
            isSensor = false
            friction = 0.6f
            restitution = 0.0f
            density = 4.0f
            filter = Filter().apply {
                categoryBits = B2dParameters.PLAYER_BIT
                maskBits = B2dParameters.GROUND_BIT or
                    B2dParameters.WALL_LEFT_BIT or
                    B2dParameters.WALL_RIGHT_BIT or
                    B2dParameters.WATER_BIT or
                    B2dParameters.PLAYER_BIT or
                    B2dParameters.FINISH_BIT or
                    // abilities
                    B2dParameters.FIRE_BOLT_BIT or
                    B2dParameters.FIRE_BOLT_SENSOR_BIT or
                    B2dParameters.FROST_BOLD_BIT or
                    B2dParameters.TRAP_ABILITY_BIT or

                    B2dParameters.TRAP_BIT or
                    B2dParameters.COIN_BIT
            }
            userData = playerPhysicState
        })

//        val sensorShape = EdgeShape(0.0f, 0.0f, 0.0f, (PLAYER_RADIUS / world.customScale) * 1.3)
//        val sensorShape = BoxShape(PLAYER_RADIUS / world.customScale * 0.05f, PLAYER_RADIUS / world.customScale * 1.5f)
//        val sensorShape = BoxShape(Rectangle.Companion.fromBounds(
//            left = -(PLAYER_RADIUS + 5) / world.customScale,
//            right = (PLAYER_RADIUS + 5) / world.customScale,
//            top = PLAYER_RADIUS / world.customScale,
//            bottom = (PLAYER_RADIUS + 5) / world.customScale
//        ))
        val sensorShape = PolygonShape().apply {
            setAsBox(
                hx = (PLAYER_RADIUS * 0.3 / world.customScale).toFloat(),
                hy = (PLAYER_RADIUS * 0.2 / world.customScale).toFloat(),
                center = Vec2(0f, (PLAYER_RADIUS / world.customScale).toFloat()),
                angle = Angle.ZERO
            )
        }
        val groundSensor = playerBody.createFixture(FixtureDef().apply {
            shape = sensorShape
            isSensor = true
            filter = Filter().apply {
                categoryBits = B2dParameters.PLAYER_GROUND_SENSOR
                maskBits = B2dParameters.GROUND_BIT
            }
            userData = playerPhysicState
        })

        val view = container {
//            circle(PLAYER_RADIUS)
//                .position(-PLAYER_RADIUS, -PLAYER_RADIUS)
            sprite.position(-PLAYER_RADIUS, -PLAYER_RADIUS).apply {
                scale = (28 * 2) / 32.0
            }
            addChild(sprite)
            // ground sendsor
//            line(0.0, 0.0, 0.0, PLAYER_RADIUS + 5)
//                .position(-PLAYER_RADIUS, -PLAYER_RADIUS)


        }.position(posX, posY)
        view.body = playerBody
        playerBody.view = view

        return PlayerMetadata(view, playerBody, playerPhysicState)
    }
}

data class PlayerMetadata(
    val view: Container,
    val body: Body,
    val playerPhysicState: PlayerPhysicState
)
